export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "exporter_process_container": {
            "agro_exporter_package_wrapper_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Plástico"])}
          }
        }
      },
      "en": {
        "model": {
          "exporter_process_container": {
            "agro_exporter_package_wrapper_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wrapper"])}
          }
        }
      }
    }
  })
}